export const isContainsOnlyNumbers = inputString => {
  const numbersPattern = /^[\d+]+$/

  return numbersPattern.test(inputString)
}
